// @flow
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as text from '../text'

type Props = {|
  background?: string,
  padding?: boolean,
  icon?: boolean,
  image:
    | React.Element<'img'>
    | React.Element<typeof GatsbyImage>
    | React.Element<typeof StaticImage>,
  title: string,
  paragraph: string | React.Node,
|}

export function FeatureIcon({
  image,
  title,
  paragraph,
  icon,
  ...props
}: Props) {
  return (
    <Root {...props}>
      <Image icon={icon}>{image}</Image>
      <Title color={colors.fadedPurple}>{title}</Title>
      <text.P3 color={colors.darkPurple70}>{paragraph}</text.P3>
    </Root>
  )
}

const Root: React.ComponentType<any> = styled.div`
  background: ${(p) => p.background || 'transparent'};
  border-radius: 10px;
  ${({ padding }) => (padding ? 'padding: 30px 30px 25px' : '')};
  margin-bottom: 30px;
  ${media.mq[1]} {
    flex: 1;
  }
`

const Image = styled.div`
  ${({ icon }) =>
    icon
      ? css``
      : css`
          text-align: center;
          img {
            height: 100px;
            object-fit: contain;
            ${media.mq[2]} {
              height: 140px;
            }
          }
        `};
`

const Title = styled(text.H5)`
  margin: 15px 0 10px;
  line-height: 1.2;
`
